











import { Component, Prop, Vue } from 'vue-property-decorator'
import { Appointments, UserState, Locations, WaitlistItem, Templates } from '../models'
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

@Component({})
export default class Header extends Vue {
  protected Locations = Locations

  protected date: string = Locations.calculateTime()
  protected updateDate: any

  get logoImageUrl() {
    return Templates.logoImageUrl
  }

  get locationName() {
    const activeLocation = Locations.activeLocation
    if (!activeLocation) {
      return ''
    }
    const name = activeLocation.nickname || activeLocation.street_address
    return name
  }

  protected created() {
    this.updateDate = setInterval(() => {
      this.date = Locations.calculateTime()
    }, 1000)
  }

  protected beforeDestroy() {
    clearInterval(this.updateDate)
  }

  protected logout() {
    UserState.LOGOUT()
  }

  protected resetLocation() {
    Locations.RESET()
    Templates.RESET()
  }
}
